module.exports = __webpack_public_path__ + "img/logo-2-zh.c2d2fd73.png";